import React from 'react';
import { BadgeProps, BadgeVariant } from './types';

const variantStyles: Record<BadgeVariant, string> = {
	default: 'bg-gray-100 text-gray-800',
	red: 'bg-red-100 text-red-800',
	yellow: 'bg-yellow-100 text-yellow-800',
	green: 'bg-green-100 text-green-800',
	blue: 'bg-blue-100 text-blue-800',
	indigo: 'bg-indigo-100 text-indigo-800',
	purple: 'bg-purple-100 text-purple-800',
	pink: 'bg-pink-100 text-pink-800',
	't-blue': 'bg-t-blue text-white',
	't-orange': 'bg-t-orange text-white',
	't-green': 'bg-t-green text-white',
	't-purple': 'bg-t-purple text-white'
};

export const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
	({ text, icon: Icon, variant = 'default', className = '' }, ref) => {
		return (
			<div
				ref={ref}
				className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${variantStyles[variant]} ${className} `}
				role='status'
			>
				{Icon && Icon}
				<span>{text}</span>
			</div>
		);
	}
);

Badge.displayName = 'Badge';
